import { careModelAnalytics } from 'src/services/analytics';

// eslint-disable-next-line import/prefer-default-export
export function useCohortSuggestedUpdatesAnalytics() {
  function trackSuggestedUpdatesModalShown(clientsCount) {
    careModelAnalytics.trackCohortSuggestedUpdatesShown(
      clientsCount,
    );
  }

  function trackSuggestedUpdatesModalConfirmed(acceptedCount) {
    careModelAnalytics.trackCohortSuggestedUpdatesConfirmed(
      acceptedCount,
    );
  }

  function trackSuggestedUpdatesModalCancelled(ignoredCount) {
    careModelAnalytics.trackCohortSuggestedUpdatesCancelled(
      ignoredCount,
    );
  }

  return {
    trackSuggestedUpdatesModalShown,
    trackSuggestedUpdatesModalConfirmed,
    trackSuggestedUpdatesModalCancelled,
  };
}
